import type { Components } from "react-markdown";

// Keep the renderer identity stable so updates retain the table's scroll container.
export const MarkdownTable: Components["table"] = ({
  children,
  node: _node,
  ...props
}) => (
  <div className="prose-chat-table">
    <table {...props}>{children}</table>
  </div>
);
